export default __webpack_public_path__ + "static/media/googlestore.de325dbb.png";